import { createContext } from "react";

export interface UserOptions {
  edit: string;
  create: string;
  delete: string;
}

interface AppContextType {
  userRole: string[];
  companyType: string;
  accountDetails: any;
  license: string;
  setAccountDetails: (accountDetails: any) => void;
  notify: any;
  toastNotify: (toastNotify: any) => void;
  bapIds:any;
  setBapIds:(bapIds:any)=>void;
}

export const AppContext = createContext<AppContextType>({
  userRole: [""],
  companyType: "",
  accountDetails: null, // Provide an initial value for accountDetails
  license: "", // Provide an initial value for license
  setAccountDetails: () => {}, // Provide an empty function as initial value
  notify: null,
  toastNotify: () => {},
  bapIds:[],
  setBapIds:()=>{}
});
